import React from "react";
import styled from "styled-components";

import CaseStudiesFold1 from "../components/Projects/CaseStudiesFold1";
import StudiesFold from "../components/Projects/StudiesFold";
import TrackingComponent from "../components/Tracking/TrackingComponent";
import { Helmet } from "react-helmet-async";

const ProjectsPage = () => {
  return (
    <>
      <Helmet>
        <title>Our Work | appssemble Projects and Case Studies</title>
        <meta
          name="description"
          content="Explore appssemble's portfolio of digital products—from HDR photo apps to AI-enabled platforms. Discover how we build fast, user-focused solutions for modern businesses."
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="appssemble" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Our Work | appssemble Projects and Case Studies"
        />
        <meta
          property="og:description"
          content="From HDR photography to AI apps, explore how appssemble builds powerful, scalable digital solutions for iOS, web, and beyond."
        />
        <meta property="og:url" content="https://appssemble.com/projects" />
        <meta
          property="og:image"
          content="https://appssemble.com/appssemble-meta.jpeg"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Our Work | appssemble Projects and Case Studies"
        />
        <meta
          name="twitter:description"
          content="See real-world examples of how appssemble designs and delivers innovative products—from ML to AR to UX-focused mobile apps."
        />
        <meta
          name="twitter:image"
          content="https://appssemble.com/appssemble-meta.jpeg"
        />

        <link rel="canonical" href="https://appssemble.com/projects" />
      </Helmet>
      <Wrapper>
        <CaseStudiesFold1 />
        <StudiesFold />
        <TrackingComponent />
      </Wrapper>
    </>
  );
};

export default ProjectsPage;

const Wrapper = styled.div`
  background: white;
`;
